import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { SeismicProgramDto } from '@cradua/data';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-seismic-program',
  templateUrl: './seismic-program.component.html',
  styleUrls: ['./seismic-program.component.scss'],
})
export class SeismicProgramComponent implements OnChanges {
  programForm: FormGroup;
  programFormArray: FormGroup;
  control = new FormControl();
  @Input() programs: SeismicProgramDto[];
  @Input() routeAnimationsElements: any;
  @Output() program = new EventEmitter<SeismicProgramDto[]>();
  @Output() deleteProgramEvent = new EventEmitter<any>();

  selectedProgram: any;
  filteredDelete: Array<any> = [];
  loading = true;
  selectedIndex = null;
  constructor(private fb: FormBuilder) {}

  ngOnChanges() {
    this.createProgramForm();
  }

  createProgramForm() {
    this.programForm = this.fb.group({
      ProgramName: ['', Validators.required],
      id: null,
    });
    this.programFormArray = this.fb.group({
      Programs: this.fb.array([]),
    });
    this.setProgram();
  }

  // method to display programs
  setProgram() {
    const control = this.programFormArray.controls.Programs as FormArray;
    this.programs.forEach((e) => {
      control.push(
        this.fb.group({
          ProgramName: e.ProgramName,
          id: e.id,
        })
      );
    });
  }

  // method to add Program
  addProgram(value: SeismicProgramDto) {
    const control = this.programFormArray.controls.Programs as FormArray;
    control.insert(
      0,
      this.fb.group({
        ProgramName: value.ProgramName,
        id: null,
      })
    );
  }

  selectProgram(value) {}

  // method to delete program from arrary list
  deleteProgram(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.programFormArray.controls.Programs as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.programs.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.programs[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  addNew(formValue: SeismicProgramDto) {
    if (this.programForm.invalid) {
      return Swal.fire(
        'Warning!',
        'Please, you cannot add blank field',
        'warning'
      );
    }
    if (this.selectedIndex != null) {
      this.programFormArray
        .get('Programs')
        ['controls'][this.selectedIndex].patchValue({
          ProgramName: formValue.ProgramName,
        });
    } else {
      this.addProgram(formValue);
    }
    this.selectedIndex = null;
    this.programForm.reset();
  }

  onEdit(index, value: SeismicProgramDto) {
    console.log(index, value);
    this.selectedIndex = index;
    this.programForm.patchValue({
      ProgramName: value.ProgramName,
    });
  }

  onClearForm() {
    this.selectedIndex = null;
    this.programForm.reset();
  }

  onSubmit(formValue: SeismicProgramDto[]) {
    this.program.emit(formValue);
    if (this.filteredDelete.length !== 0) {
      this.deleteProgramEvent.emit(this.filteredDelete);
    }
  }
}
